<div class="response-graph-container">
    <div class="response-header">
        <div class="response-title">Response</div>
        <div class="response-units">(mV)</div>
        <div class="scale-controls">
            <button class="scale-btn" (click)="scaleDown()" title="Increase scale">+</button>
            <button class="scale-btn" (click)="scaleUp()" title="Decrease scale">−</button>
        </div>
    </div>

    <div class="chart-wrapper">
        <canvas #responseCanvas class="response-canvas" [width]="canvasWidth" [height]="canvasHeight"> </canvas>
    </div>
</div>
